import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { StickyNote } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { Button } from "@/components/ui/button";
import Authorized from "components/Authorized";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import {
  invalidateNoteTemplateQuery,
  useNoteTemplateTable,
} from "hooks/useNoteTemplateTable";
import NoteTemplateService from "services/NoteTemplate";
import {
  NOTE_TEMPLATE_TABLE_CONSTANTS,
  NOTE_TEMPLATES_PATH,
} from "routes/note_template/NoteTemplateTableConstants";

// TableTop renders a string headerIcon through Semantic's Icon; passing a node
// keeps this page free of Semantic UI.
const headerIcon = (
  <span
    className="tw:inline-flex tw:size-8 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:bg-primary tw:text-primary-foreground"
    aria-hidden="true"
  >
    <StickyNote className="tw:size-4" />
  </span>
);

const NoteTemplateTableV3 = () => {
  const navigate = useNavigate();
  const { columns } = useNoteTemplateTable({
    tableName: NOTE_TEMPLATE_TABLE_CONSTANTS.tableName,
  });

  const fetchNoteTemplates = useCallback(
    async queryParams => {
      const nextQueryParams = getNextQueryParams(queryParams, columns);
      return NoteTemplateService.getTable(nextQueryParams);
    },
    [columns]
  );

  const createButton = (
    <Authorized permissions={[ACL_RELATIONSHIPS.noteTemplate.create]}>
      <Button size="sm" onClick={() => navigate(`${NOTE_TEMPLATES_PATH}/new`)}>
        New Note Template
      </Button>
    </Authorized>
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={headerIcon}
      header={NOTE_TEMPLATE_TABLE_CONSTANTS.header}
      queryKey={NOTE_TEMPLATE_TABLE_CONSTANTS.queryKey}
      className={NOTE_TEMPLATE_TABLE_CONSTANTS.className}
      tableName={NOTE_TEMPLATE_TABLE_CONSTANTS.tableName}
      createButton={createButton}
      fetchData={fetchNoteTemplates}
      invalidateData={invalidateNoteTemplateQuery}
      enableSearch
      enableSettings
    />
  );
};

export default NoteTemplateTableV3;
